module.exports = __webpack_public_path__ + "media/images/icons/courses/8-eff03c679ae7c4c935fbbdff250732b0.svg";